import { z } from 'zod'

import { emailSchema } from './emailSchema'
import { passwordSchema } from './passwordSchema'

/**
 * 登录表单验证
 */
export const loginFormSchema = z.object({}).merge(emailSchema).merge(passwordSchema)

export type TLoginFormSchema = z.infer<typeof loginFormSchema>
